document.addEventListener("DOMContentLoaded", () => {
  // 1. Kích hoạt tính năng click zoom & kính lúp ô vuông sản phẩm
  initProductMediaZoom();

  // 2. Kích hoạt slider cuộn ngang trên Mobile
  if (window.innerWidth <= 768) {
    initMobileSwiper();
  }
});

function initProductMediaZoom() {
  const gallery = document.querySelector(".custom-media-gallery");
  if (!gallery) return;

  const lightbox = gallery.querySelector(".media-zoom-lightbox") || document.querySelector(".media-zoom-lightbox");
  if (!lightbox) return;

  // Di chuyển lightbox ra document.body để z-index hiển thị trên cùng không bị che
  if (lightbox.parentElement !== document.body) {
    document.body.appendChild(lightbox);
  }

  const lightboxOverlay = lightbox.querySelector(".media-zoom-lightbox__overlay");
  const lightboxClose = lightbox.querySelector(".media-zoom-lightbox__close");
  const lightboxPrev = lightbox.querySelector(".media-zoom-lightbox__prev");
  const lightboxNext = lightbox.querySelector(".media-zoom-lightbox__next");
  const lightboxImage = lightbox.querySelector(".media-zoom-lightbox__image");
  const lightboxCounterCurrent = lightbox.querySelector(".media-zoom-lightbox__current");
  const lightboxCounterTotal = lightbox.querySelector(".media-zoom-lightbox__total");
  const lightboxStage = lightbox.querySelector(".media-zoom-lightbox__stage");
  const lightboxZoomBadge = lightbox.querySelector(".media-zoom-lightbox__zoom-badge");

  const mediaItems = Array.from(gallery.querySelectorAll(".custom-media-item:not(.cloned) .custom-media-image"));
  if (mediaItems.length === 0) return;

  const imagesData = mediaItems.map((img, i) => ({
    fullSrc: img.getAttribute("data-full-src") || img.src,
    alt: img.alt || "",
    index: i
  }));

  let activeIndex = 0;
  let zoomStage = 0; // 0: 1.5x (mặc định), 1: 2.8x, 2: 4.2x
  const zoomScales = [1.5, 2.8, 4.2];

  // Pan coordinates khi kéo chuột
  let currentPanX = 0;
  let currentPanY = 0;
  let isPanDragging = false;
  let panStartX = 0;
  let panStartY = 0;
  let startPanX = 0;
  let startPanY = 0;
  let dragDistance = 0;

  function applyTransform() {
    if (!lightboxImage) return;
    const scale = zoomScales[zoomStage];
    lightboxImage.style.transform = `translate(${currentPanX}px, ${currentPanY}px) scale(${scale})`;
    lightboxImage.classList.add("is-zoomed");
    if (zoomStage === 2) {
      lightboxImage.classList.add("is-zoomed-2");
    } else {
      lightboxImage.classList.remove("is-zoomed-2");
    }
  }

  function setZoomStage(stage) {
    zoomStage = (stage + zoomScales.length) % zoomScales.length;
    const scale = zoomScales[zoomStage];

    currentPanX = 0;
    currentPanY = 0;

    applyTransform();

    if (lightboxZoomBadge) {
      lightboxZoomBadge.textContent = `${scale}x`;
    }
  }

  function resetZoom() {
    currentPanX = 0;
    currentPanY = 0;
    setZoomStage(0);
  }

  function updateLightboxImage(index) {
    if (index < 0) index = imagesData.length - 1;
    if (index >= imagesData.length) index = 0;
    activeIndex = index;

    if (lightboxImage) {
      lightboxImage.src = imagesData[activeIndex].fullSrc;
      lightboxImage.alt = imagesData[activeIndex].alt;
    }
    if (lightboxCounterCurrent) {
      lightboxCounterCurrent.textContent = activeIndex + 1;
    }
    if (lightboxCounterTotal) {
      lightboxCounterTotal.textContent = imagesData.length;
    }

    const thumbs = lightbox.querySelectorAll(".media-zoom-lightbox__thumb");
    thumbs.forEach((thumb, i) => {
      const isActive = i === activeIndex;
      thumb.classList.toggle("active", isActive);
      if (isActive) {
        thumb.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    });

    resetZoom();
  }

  // Kéo chuột giữ để di chuyển ảnh khi zoom (Click & Drag Pan)
  if (lightboxImage) {
    lightboxImage.addEventListener("mousedown", (e) => {
      e.preventDefault();
      isPanDragging = true;
      dragDistance = 0;
      panStartX = e.clientX;
      panStartY = e.clientY;
      startPanX = currentPanX;
      startPanY = currentPanY;
      lightboxImage.classList.add("is-dragging");
    });
  }

  window.addEventListener("mousemove", (e) => {
    if (!isPanDragging) return;
    const dx = e.clientX - panStartX;
    const dy = e.clientY - panStartY;
    dragDistance = Math.sqrt(dx * dx + dy * dy);

    currentPanX = startPanX + dx;
    currentPanY = startPanY + dy;
    applyTransform();
  });

  window.addEventListener("mouseup", () => {
    if (!isPanDragging) return;
    isPanDragging = false;
    if (lightboxImage) lightboxImage.classList.remove("is-dragging");
  });

  // Click vào ảnh trong Lightbox để đổi mức Zoom (chỉ khi không kéo chuột)
  if (lightboxImage) {
    lightboxImage.addEventListener("click", (e) => {
      e.stopPropagation();
      if (dragDistance > 6) return;
      const nextStage = (zoomStage + 1) % zoomScales.length;
      setZoomStage(nextStage);
    });
  }

  // Con trỏ cuộn chuột để zoom thêm/bớt
  if (lightboxStage) {
    lightboxStage.addEventListener("wheel", (e) => {
      if (!lightbox.classList.contains("is-open")) return;
      e.preventDefault();
      if (e.deltaY < 0) {
        if (zoomStage < zoomScales.length - 1) setZoomStage(zoomStage + 1);
      } else if (e.deltaY > 0) {
        if (zoomStage > 0) setZoomStage(zoomStage - 1);
      }
    }, { passive: false });
  }

  function openLightbox(index) {
    updateLightboxImage(index);
    lightbox.classList.add("is-open");
    lightbox.setAttribute("aria-hidden", "false");
    document.body.classList.add("media-zoom-open");
  }

  function closeLightbox() {
    lightbox.classList.remove("is-open");
    lightbox.setAttribute("aria-hidden", "true");
    document.body.classList.remove("media-zoom-open");
    resetZoom();
  }

  // Click vào ảnh ở gallery để mở Lightbox
  gallery.addEventListener("click", (e) => {
    const img = e.target.closest(".custom-media-image");
    if (!img) return;

    if (window.customMediaIsDragging) return;

    e.preventDefault();
    e.stopPropagation();

    const dataIndex = img.getAttribute("data-index");
    let index = dataIndex !== null ? parseInt(dataIndex, 10) : 0;

    openLightbox(index);
  });

  // Click vào thumbnail nằm ngang ở dưới Lightbox để chuyển ảnh trực tiếp
  const lightboxThumbnails = lightbox.querySelector(".media-zoom-lightbox__thumbnails");
  if (lightboxThumbnails) {
    lightboxThumbnails.addEventListener("click", (e) => {
      const btn = e.target.closest(".media-zoom-lightbox__thumb");
      if (!btn) return;
      e.stopPropagation();
      const idx = parseInt(btn.getAttribute("data-index"), 10);
      updateLightboxImage(idx);
    });
  }

  // Chuyển ảnh Next / Prev bằng chuột
  if (lightboxPrev) {
    lightboxPrev.addEventListener("click", (e) => {
      e.stopPropagation();
      updateLightboxImage(activeIndex - 1);
    });
  }
  if (lightboxNext) {
    lightboxNext.addEventListener("click", (e) => {
      e.stopPropagation();
      updateLightboxImage(activeIndex + 1);
    });
  }

  // Đóng Lightbox (Nút X, Nền hoặc phím Esc)
  if (lightboxClose) lightboxClose.addEventListener("click", closeLightbox);
  if (lightboxOverlay) lightboxOverlay.addEventListener("click", closeLightbox);
  if (lightboxStage) {
    lightboxStage.addEventListener("click", (e) => {
      if (e.target === lightboxStage || e.target.classList.contains("media-zoom-lightbox__img-wrapper")) {
        closeLightbox();
      }
    });
  }

  document.addEventListener("keydown", (e) => {
    if (!lightbox.classList.contains("is-open")) return;
    if (e.key === "Escape") closeLightbox();
    if (e.key === "ArrowLeft") updateLightboxImage(activeIndex - 1);
    if (e.key === "ArrowRight") updateLightboxImage(activeIndex + 1);
  });

  // 🔹 Kính lúp ô vuông di theo chuột ngoài gallery (Desktop)
  if (window.innerWidth > 768) {
    initHoverLensBox(gallery);
  }
}

// Kính lúp vuông rà theo chuột ngoài gallery (Desktop)
function initHoverLensBox(gallery) {
  const items = gallery.querySelectorAll(".custom-media-item");

  items.forEach((item) => {
    const img = item.querySelector(".custom-media-image");
    if (!img) return;

    let lensBox = item.querySelector(".custom-media-lens-box");
    if (!lensBox) {
      lensBox = document.createElement("div");
      lensBox.className = "custom-media-lens-box";
      item.appendChild(lensBox);
    }

    const LENS_SIZE = 280;
    const ZOOM_FACTOR = 3.8;

    item.addEventListener("mouseenter", () => {
      const fullSrc = img.getAttribute("data-full-src") || img.src;
      lensBox.style.backgroundImage = `url('${fullSrc}')`;
      lensBox.style.display = "block";
    });

    item.addEventListener("mousemove", (e) => {
      const rect = item.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      let posX = x - LENS_SIZE / 2;
      let posY = y - LENS_SIZE / 2;

      lensBox.style.left = `${posX}px`;
      lensBox.style.top = `${posY}px`;

      const bgWidth = rect.width * ZOOM_FACTOR;
      const bgHeight = rect.height * ZOOM_FACTOR;
      const bgX = -(x * ZOOM_FACTOR - LENS_SIZE / 2);
      const bgY = -(y * ZOOM_FACTOR - LENS_SIZE / 2);

      lensBox.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;
      lensBox.style.backgroundPosition = `${bgX}px ${bgY}px`;
    });

    item.addEventListener("mouseleave", () => {
      lensBox.style.display = "none";
    });
  });
}

function initMobileSwiper() {
  const swiperContainer = document.querySelector(".custom-media-gallery");
  const swiperWrapper = swiperContainer?.querySelector(".custom-media-list");
  let slides = swiperWrapper?.querySelectorAll(".custom-media-item");

  if (!swiperContainer || !swiperWrapper || slides.length === 0) return;

  const slideCount = slides.length;
  let currentIndex = 1;
  let startX = 0;
  let startY = 0;
  let isDragging = false;
  let isTransitioning = false;
  let isHorizontalSwipe = false;

  if (!swiperWrapper.querySelector(".custom-media-item.cloned")) {
    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slideCount - 1].cloneNode(true);
    firstClone.classList.add("cloned");
    lastClone.classList.add("cloned");
    swiperWrapper.appendChild(firstClone);
    swiperWrapper.insertBefore(lastClone, slides[0]);
    slides = swiperWrapper.querySelectorAll(".custom-media-item");
  }

  swiperWrapper.style.width = `${slides.length * 100}%`;
  swiperWrapper.style.willChange = "transform";
  swiperWrapper.style.webkitTransform = "translateZ(0)";
  swiperWrapper.style.transform = "translateZ(0)";

  const getSlideWidth = () => slides[0].getBoundingClientRect().width;

  const updateIndicators = () => {
    const indicatorContainer = swiperContainer.querySelector(".custom-media-pagination");
    if (!indicatorContainer) return;
    const indicatorIndex = ((currentIndex - 1) % slideCount + slideCount) % slideCount;
    const indicators = indicatorContainer.querySelectorAll(".custom-media-indicator");
    indicators.forEach((ind, i) => {
      ind.classList.toggle("active", i === indicatorIndex);
    });
  };

  let transitionFallbackTimer = null;
  const TRANSITION_DURATION = 300;

  const clearTransitionFallback = () => {
    if (transitionFallbackTimer) {
      clearTimeout(transitionFallbackTimer);
      transitionFallbackTimer = null;
    }
  };

  const setSliderPosition = (instant = false) => {
    const slideWidth = getSlideWidth();

    if (instant) {
      requestAnimationFrame(() => {
        swiperWrapper.style.transition = "none";
        swiperWrapper.style.webkitTransition = "none";
        swiperWrapper.style.transform = `translateX(-${slideWidth * currentIndex}px)`;
        swiperWrapper.style.webkitTransform = `translateX(-${slideWidth * currentIndex}px)`;
        isTransitioning = false;
        updateIndicators();
      });
    } else {
      swiperWrapper.style.transition = "transform 0.3s ease-out";
      swiperWrapper.style.webkitTransition = "-webkit-transform 0.3s ease-out";
      swiperWrapper.style.transform = `translateX(-${slideWidth * currentIndex}px)`;
      swiperWrapper.style.webkitTransform = `translateX(-${slideWidth * currentIndex}px)`;
      isTransitioning = true;
      updateIndicators();
    }
  };

  const handleLoop = () => {
    clearTransitionFallback();

    if (currentIndex === 0) {
      currentIndex = slideCount;
      setSliderPosition(true);
    } else if (currentIndex === slides.length - 1) {
      currentIndex = 1;
      setSliderPosition(true);
    } else {
      isTransitioning = false;
    }
  };

  const safeSetSliderPosition = (instant = false) => {
    setSliderPosition(instant);

    if (!instant) {
      clearTransitionFallback();

      const onTransitionEnd = () => {
        swiperWrapper.removeEventListener("transitionend", onTransitionEnd);
        swiperWrapper.removeEventListener("webkitTransitionEnd", onTransitionEnd);
        handleLoop();
      };

      swiperWrapper.addEventListener("transitionend", onTransitionEnd, { once: true });
      swiperWrapper.addEventListener("webkitTransitionEnd", onTransitionEnd, { once: true });

      transitionFallbackTimer = setTimeout(() => {
        swiperWrapper.removeEventListener("transitionend", onTransitionEnd);
        swiperWrapper.removeEventListener("webkitTransitionEnd", onTransitionEnd);
        handleLoop();
      }, TRANSITION_DURATION + 50);
    } else {
      handleLoop();
    }
  };

  const touchStart = (e) => {
    if (isTransitioning) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDragging = true;
    window.customMediaIsDragging = false;
    isHorizontalSwipe = false;
  };

  const touchMove = (e) => {
    if (!isDragging) return;

    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    const deltaX = currentX - startX;
    const deltaY = currentY - startY;

    if (Math.abs(deltaX) > 8) {
      window.customMediaIsDragging = true;
    }

    if (!isHorizontalSwipe && Math.abs(deltaX) > 10) {
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        isHorizontalSwipe = true;
      }
    }

    if (isHorizontalSwipe) {
      e.preventDefault();
      const slideWidth = getSlideWidth();
      const currentTranslate = -slideWidth * currentIndex + deltaX;
      swiperWrapper.style.transition = "none";
      swiperWrapper.style.webkitTransition = "none";
      swiperWrapper.style.transform = `translateX(${currentTranslate}px)`;
      swiperWrapper.style.webkitTransform = `translateX(${currentTranslate}px)`;
    }
  };

  const touchEnd = (e) => {
    if (!isDragging) return;
    isDragging = false;

    setTimeout(() => {
      window.customMediaIsDragging = false;
    }, 100);

    if (!isHorizontalSwipe) return;

    const endX = e.changedTouches[0].clientX;
    const deltaX = endX - startX;

    if (Math.abs(deltaX) < 50 || isTransitioning) {
      safeSetSliderPosition();
    } else {
      if (deltaX < -50 && currentIndex < slides.length - 1) {
        currentIndex++;
      } else if (deltaX > 50 && currentIndex > 0) {
        currentIndex--;
      }
      safeSetSliderPosition();
    }

    isHorizontalSwipe = false;
  };

  const AUTO_SCROLL_DELAY = 4000;
  let autoScrollTimer = null;
  let isAutoScrollPaused = false;

  const startAutoScroll = () => {
    stopAutoScroll();
    if (isAutoScrollPaused) return;
    autoScrollTimer = setInterval(() => {
      if (isDragging || isTransitioning) return;
      currentIndex++;
      safeSetSliderPosition();
    }, AUTO_SCROLL_DELAY);
  };

  const stopAutoScroll = () => {
    if (autoScrollTimer) {
      clearInterval(autoScrollTimer);
      autoScrollTimer = null;
    }
  };

  const wrappedTouchStart = (e) => {
    stopAutoScroll();
    touchStart(e);
  };

  const wrappedTouchEnd = (e) => {
    touchEnd(e);
    startAutoScroll();
  };

  swiperWrapper.addEventListener("touchstart", wrappedTouchStart, { passive: false });
  swiperWrapper.addEventListener("touchmove", touchMove, { passive: false });
  swiperWrapper.addEventListener("touchend", wrappedTouchEnd);

  const indicatorContainer = swiperContainer.querySelector(".custom-media-pagination");
  if (indicatorContainer) {
    indicatorContainer.addEventListener("click", (e) => {
      const indicator = e.target.closest(".custom-media-indicator");
      if (!indicator || isTransitioning) return;
      const targetIndex = parseInt(indicator.getAttribute("data-index"), 10);
      currentIndex = targetIndex + 1;
      stopAutoScroll();
      safeSetSliderPosition();
      startAutoScroll();
    });
  }

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            isAutoScrollPaused = false;
            startAutoScroll();
          } else {
            isAutoScrollPaused = true;
            stopAutoScroll();
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(swiperContainer);
  }

  safeSetSliderPosition(true);
  startAutoScroll();
}
